(ns kyber.kyber-db.activity)

(def model
  {:ident-key
   :activity/uuid

   :refs
   {:activity/primary-learning-object
    {:model :activity-resource
     :cardinality :one}

    :activity/external-users
    {:model :external-user
     :cardinality :many}

    :activity/evaluation
    {:model :questionnaire
     :cardinality :one}

    :activity/post-test
    {:model :questionnaire
     :cardinality :one}

    :activity/pre-test
    {:model :questionnaire
     :cardinality :one}

    :activity/assessment
    {:model :assessment
     :cardinality :one}

    :activity/floating-questionnaires
    {:model :questionnaire
     :cardinality :many}

    :activity/moments
    {:model :moment
     :cardinality :many}

    :activity/learning-objectives
    {:model :learning-objective
     :cardinality :many}

    :activity/resources
    {:model :activity-resource
     :cardinality :many}}

   :schema
   #:activity
   {:uuid
    {:doc "UUID of an activity"}

    :allow-disabling-of-cbqs
    {:doc "Super user setting allowing content admins can disable confidence based questions"}

    :allow-unmatched-graded-questions
    {:doc "Super user setting allowing content admins to not match graded questions on the pre/post tests"}

    :boosts
    {:doc "Boosts attached to the activity"}

    :cme-front-matter-enabled
    {:doc "Should front matter be shown"}

    :cme-front-matter-url
    {:doc "URL of front matter object"}

    :combined-test
    {:doc ""}

    :completion-threshold
    {:doc "When a user is considered complete from the application's perspective"}

    :cornerstone-config
    {:doc "Cornerstone configuration"}

    :description
    {:doc ""}

    :external-activity-link
    {:doc ""}

    :future-scrubbing-enabled
    {:doc ""}

    :is-intro-activity?
    {:doc ""}

    :is-supplemental?
    {:doc "If true, the activity is not required"}

    :looker
    {:doc ""}

    :name
    {:doc "Name of an activity"}

    :note-taking-enabled
    {:doc ""}

    :plo-type
    {:doc ""}

    :poster
    {:doc ""}

    :primary-learning-object
    {:doc "Primary learning object resource"}

    :published-on
    {:doc ""}

    :ai-enabled
    {:doc ""}

    :questionnaires
    {:doc ""}

    :show-all-moments
    {:doc ""}

    :sign-in-display-name
    {:doc ""}

    :sort-order
    {:doc ""}

    :tile
    {:doc ""}

    :valid-tags
    {:docs "Tags that are assigned to the activity. These are used to filter activities on the learner."}}})
